export default __webpack_public_path__ + "static/media/custom.06d5e7ed.png";